import {
  NEUTRAL,
  SUCCESS,
  ERROR,
  WARNING,
  TERTIARY,
  BACKGROUND,
  TEXT,
  PRIMARY_LEARN,
  PRIMARY_META,
  SECONDARY_META,
  OVERLAY,
  TEST,
  BUTTON_SUCCESS,
  DOUBTS_RESOLVED,
  DOUBT_IMAGE_EDIT_GRADIENT,
  AINA_CHAT,
} from "../../primitives/colors";
import type { ThemeColors } from "../../semantic/colors";
import { buildSubjectColors } from "./subjectColors";

export const metaColors: ThemeColors = {
  primary: PRIMARY_META,
  secondary: SECONDARY_META,
  tertiary: TERTIARY,
  neutral: NEUTRAL,
  success: SUCCESS,
  error: ERROR,
  warning: WARNING,
  text: TEXT,
  background: BACKGROUND,
  subject: buildSubjectColors({
    primary: PRIMARY_LEARN,
    warning: WARNING,
    success: SUCCESS,
    error: ERROR,
    tertiary: TERTIARY,
  }),
  overlay: OVERLAY,
  test: TEST,
  buttonSuccess: BUTTON_SUCCESS,
  ainaChat: AINA_CHAT,
  doubtsResolved: DOUBTS_RESOLVED,
  doubtImageEditGradient: DOUBT_IMAGE_EDIT_GRADIENT,
};
